var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWf09W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 20,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Framesolutons",
    transform: "translate(15 16)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M.008,13.838v-.175c0-3.167.01-6.333-.008-9.5A1.388,1.388,0,0,1,1.344,2.769c.6.012,1.2,0,1.805,0h.187c0-.232,0-.45,0-.667a.68.68,0,0,1,.641-.713.661.661,0,0,1,.689.657c.013.234,0,.469,0,.713H6.662V2.584q0-.929,0-1.857A.676.676,0,0,1,7.357,0Q10,0,12.646,0a.68.68,0,0,1,.693.73c0,.614,0,1.227,0,1.841v.188h1.977c0-.22,0-.442,0-.664a.682.682,0,0,1,.729-.706.7.7,0,0,1,.616.745c0,.207,0,.413,0,.635h.583c.491,0,.982,0,1.473,0A1.331,1.331,0,0,1,19.993,4.1q0,4.816,0,9.631c0,.032,0,.065,0,.108ZM8.662,2.772c0,.051.01.083.01.115,0,1.216,0,2.432,0,3.648a.32.32,0,0,1-.085.2q-.5.53-1.006,1.047a.785.785,0,0,0-.24.569c0,1.145-.007,2.29,0,3.434a.662.662,0,0,0,.7.689q1.3,0,2.6,0a.669.669,0,0,0,.7-.7c.006-1.139,0-2.278,0-3.418a.777.777,0,0,0-.237-.569c-.335-.341-.669-.685-.994-1.036a.415.415,0,0,1-.1-.254c-.006-1.178,0-2.355,0-3.533V2.771h1.994V1.4H8.017V2.772Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M19.992,15.241c0,.532.021,1.053-.005,1.571A1.348,1.348,0,0,1,18.8,17.99c-.084.007-.169.009-.253.009H1.449a1.341,1.341,0,0,1-1.382-.953.764.764,0,0,1-.053-.222c-.006-.465-.005-.931-.007-1.4V15.24H19.992Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M9.332,7.887c.219.229.427.445.631.664a.187.187,0,0,1,.043.116q0,1.182,0,2.363a.185.185,0,0,1-.015.042H8.669c0-.053-.007-.11-.008-.168,0-.722,0-1.444,0-2.167a.407.407,0,0,1,.094-.24C8.939,8.291,9.133,8.1,9.332,7.887Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf09W);
export default __webpack_public_path__ + "static/media/icon-wf-09-w.190f3cd1dfb93348ca58cf2ed051363e.svg";
export { ForwardRef as ReactComponent };